import { ArrowRightLeft, Briefcase, LineChart, MessagesSquare, Landmark } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [ArrowRightLeft, LineChart, Briefcase, MessagesSquare];

export const ServicesSection = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="bg-white py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Overline>{t.services.overline}</Overline>
          <h2 className="mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 max-w-2xl">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08} className="h-full">
                <div data-testid={`service-card-${i}`} className="group bg-white h-full p-8 hover:bg-[#FAF9F6] transition-colors duration-500">
                  <div className="w-11 h-11 rounded-full border border-slate-200 flex items-center justify-center text-slate-700 group-hover:border-emerald-600 group-hover:text-emerald-700 transition-colors duration-500">
                    <Icon size={18} strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-6 text-lg font-medium text-slate-900">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div data-testid="family-office-spotlight" className="mt-8 bg-emerald-900 text-white p-10 lg:p-16 relative overflow-hidden">
            <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full border border-emerald-700/50" />
            <div className="absolute -right-8 -top-8 w-72 h-72 rounded-full border border-emerald-700/30" />
            <div className="relative max-w-3xl">
              <div className="flex items-center gap-3">
                <Landmark size={20} className="text-emerald-300" />
                <span className="text-xs font-mono uppercase tracking-[0.25em] text-emerald-300">{t.services.foTag}</span>
              </div>
              <h3 className="mt-5 font-serif text-2xl lg:text-3xl font-semibold">{t.services.foTitle}</h3>
              <p className="mt-4 text-emerald-100/90 leading-relaxed text-base lg:text-lg">{t.services.foBody}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
